export default __webpack_public_path__ + "static/borba-5c96935db04050ed58423f6827604c89.jpg";